import { UserStatus } from "@fena/toolkit-types";
import api from "./api";
import { FullUserCompanyMembership } from "./types";
const getCM = (companyMemberships: FullUserCompanyMembership[], id: string) => {
  return companyMemberships.find(
    (companyMembership) =>
      companyMembership.company._id === id &&
      companyMembership.deletedAt === null &&
      companyMembership.status === UserStatus.ACTIVE
  );
};

export const setSelectedCompanyMembership = (
  userMemberships: FullUserCompanyMembership[],
  selectedCompanyId?: string
) => {
  if (selectedCompanyId) {
    const found = getCM(userMemberships, selectedCompanyId);
    if (found) {
      window.localStorage.setItem("selectedCompany", selectedCompanyId);

      api.updateHeadersWithSelectedCompany(selectedCompanyId);
      return found;
    }
  }
  const cachedId = window.localStorage.getItem("selectedCompany");
  if (cachedId) {
    const found = getCM(userMemberships, cachedId);
    if (found) {
      api.updateHeadersWithSelectedCompany(cachedId);

      return found;
    }
  }

  const defaultCM = userMemberships.find(
    (cm) => cm.deletedAt === null && cm.status === UserStatus.ACTIVE
  );
  if (defaultCM) {
    window.localStorage.setItem("selectedCompany", defaultCM.company._id);
    api.updateHeadersWithSelectedCompany(defaultCM.company._id);

    return defaultCM;
  }
  console.warn("COMPANY MEMBERSHIP NOT FOUND");
  return null;
};

export const clearSelectedCompany = () => {
  window.localStorage.removeItem("selectedCompany");
  api.updateHeadersWithSelectedCompany("");
};

// export const showDisableContent = (
//   hasPaymentsOnlySubscription: boolean,
//   canManageCompanies?: boolean,
//   hasB2BSubscription?: boolean,
//   hasToolkitSubscription?: boolean,
//   b2bSubscriptionOption?: SubscriptionOptionEnum
// ) => {
//   if (
//     !hasB2BSubscription &&
//     !hasToolkitSubscription &&
//     !hasPaymentsOnlySubscription
//   ) {
//     if (location.pathname.includes("private/inventory")) {
//       return true;
//     } else if (location.pathname.includes("order-generation")) {
//       if (hasB2BSubscription && b2bSubscriptionOption) {
//         return true;
//       }
//       return true;
//     } else if (location.pathname.includes("payments")) {
//       return true;
//     } else if (location.pathname.includes("invoices")) {
//       return true;
//     } else if (location.pathname.includes("quotes")) {
//       return true;
//     } else if (location.pathname.includes("shipments")) {
//       return true;
//     } else if (location.pathname.includes("team")) {
//       return true;
//     } else if (location.pathname.includes("bank-accounts")) {
//       if (canManageCompanies) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("roles")) {
//       return true;
//     } else if (location.pathname.includes("api-keys")) {
//       if (canManageCompanies) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("delivery")) {
//       return true;
//     } else if (location.pathname.includes("segments")) {
//       return true;
//     } else if (location.pathname.includes("integrations")) {
//       return true;
//     } else if (location.pathname.includes("settings/apps")) {
//       return true;
//     } else if (location.pathname.includes("customisation")) {
//       return true;
//     } else if (location.pathname.includes("locations")) {
//       return true;
//     } else if (location.pathname.includes("reminders")) {
//       return true;
//     } else if (location.pathname.includes("currency")) {
//       return true;
//     } else if (location.pathname.includes("terminal-management")) {
//       return true;
//     } else if (location.pathname.includes("sync-management")) {
//       return true;
//     } else {
//       return false;
//     }
//   } else if (hasPaymentsOnlySubscription) {
//     if (location.pathname.includes("private/inventory/orders")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     }
//     if (location.pathname.includes("private/reports/card-payments")) {
//       if (hasB2BSubscription) {
//         return true;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("private/inventory/products")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("private/inventory/stock")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("private/inventory/categories")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("private/inventory/brands")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("private/inventory/incoming")) {
//       return true;
//     } else if (
//       location.pathname.includes("private/inventory/rejected-and-missing")
//     ) {
//       return true;
//     } else if (location.pathname.includes("private/inventory/customers")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("private/inventory/suppliers")) {
//       return true;
//     } else if (location.pathname.includes("order-generation")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("payments")) {
//       return false;
//     } else if (location.pathname.includes("private/commercial-invoices")) {
//       if (hasB2BSubscription) {
//         return true;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("quotes")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("shipments")) {
//       return true;
//     } else if (location.pathname.includes("api-keys")) {
//       return false;
//     } else if (location.pathname.includes("delivery")) {
//       return true;
//     } else if (location.pathname.includes("segments")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("customisation/email-notification")) {
//       return false;
//     } else if (location.pathname.includes("customisation/payment-page")) {
//       return false;
//     } else if (location.pathname.includes("customisation/invoice-design")) {
//       return false;
//     } else if (location.pathname.includes("customisation/fena-checkout-flow")) {
//       return false;
//     } else if (location.pathname.includes("integrations/accounting")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("integrations/other-apps")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("integrations/e-commerce")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("integrations/marketplaces")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("apps")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("integrations/carriers")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("locations")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("reminders")) {
//       if (hasB2BSubscription) {
//         return false;
//       } else {
//         return true;
//       }
//     } else if (location.pathname.includes("sync-management")) {
//       return true;
//     } else {
//       return false;
//     }
//   } else if (hasB2BSubscription && !hasToolkitSubscription) {
//     if (location.pathname.includes("reports")) {
//       return true;
//     } else if (location.pathname.includes("suppliers")) {
//       return true;
//     } else if (location.pathname.includes("shipments")) {
//       return true;
//     } else if (location.pathname.includes("commercial-invoices")) {
//       return true;
//     } else if (location.pathname.includes("/private/payments")) {
//       return true;
//     } else if (location.pathname.includes("transactions")) {
//       return true;
//     } else if (location.pathname.includes("rejected-and-missing")) {
//       return true;
//     } else if (location.pathname.includes("inventory/incoming")) {
//       return true;
//     } else if (location.pathname.includes("terminal-management")) {
//       return true;
//     }
//   }
// };

// export const disableTabContent = (
//   hasNoSubscription: boolean,
//   hasPaymentsOnlySubscription: boolean,
//   canManageCompanies?: boolean,
//   hasB2BSubscription?: boolean,
//   hasToolkitSubscription?: boolean,
//   tabRoute?: string // Add tabRoute parameter
// ) => {
//   if (
//     !hasB2BSubscription &&
//     !hasToolkitSubscription &&
//     !hasPaymentsOnlySubscription
//   ) {
//     return [
//       "private/inventory",
//       "order-generation",
//       "payments",
//       "invoices",
//       "quotes",
//       "shipments",
//       "team",
//       "bank-accounts",
//       "roles",
//       "api-keys",
//       "delivery",
//       "segments",
//       "integrations",
//       "settings/apps",
//       "customisation",
//       "locations",
//       "reminders",
//       "currency",
//       "terminal-management",
//       "sync-management",
//     ].some((path) => tabRoute?.includes(path)); // Check against the tabRoute
//   } else if (hasPaymentsOnlySubscription) {
//     let paths = [];
//     if (hasB2BSubscription) {
//       paths = [
//         "private/inventory/suppliers",
//         "private/commercial-invoices",
//         "private/reports/card-payments",
//         "shipments",
//       ];
//     } else {
//       paths = [
//         "private/reports/card-payments",
//         "private/inventory/orders",
//         "private/inventory/products",
//         "private/inventory/stock",
//         "private/inventory/categories",
//         "private/inventory/brands",
//         "private/inventory/incoming",
//         "private/inventory/rejected-and-missing",
//         "private/inventory/customers",
//         "private/inventory/suppliers",
//         "order-generation",
//         "private/commercial-invoices",
//         "quotes",
//         "shipments",
//         "api-keys",
//         "delivery",
//       ];
//     }
//     return paths.some((path) => tabRoute?.includes(path ?? ""));
//   } else if (hasB2BSubscription && !hasToolkitSubscription) {
//     return [
//       "reports",
//       "suppliers",
//       "shipments",
//       "commercial-invoices",
//       "/private/payments",
//       "transactions",
//       "rejected-and-missing",
//       "inventory/incoming",
//       "terminal-management",
//     ].some((path) => tabRoute?.includes(path));
//   }
//   return false;
// };
